// extracted by mini-css-extract-plugin
module.exports =  {"button":"_93444fe79c--button--FzUK3","icon":"_93444fe79c--icon--yB9R1","XS":"_93444fe79c--XS--JTpSd","M":"_93444fe79c--M--TETjN"};